/**
 * Bridge zwischen den React-Touch-Controls und der Phaser-Scene.
 *
 * Wir benutzen ein gemeinsames, mutables Objekt, das die React-Komponenten
 * über Pointer-Events befüllen und die Phaser-Scene jeden Frame ausliest.
 * So bleiben die beiden Welten sauber entkoppelt – ohne Events oder Bus.
 */
export interface TouchInputState {
  left: boolean;
  right: boolean;
  jump: boolean;
  shoot: boolean;
  /** Steigt jedes Mal an, wenn `jump` neu gedrückt wird (für Edge-Erkennung). */
  jumpPulse: number;
  /** Wie oben – für Schuss-Edge. */
  shootPulse: number;
}

export const touchInput: TouchInputState = {
  left: false,
  right: false,
  jump: false,
  shoot: false,
  jumpPulse: 0,
  shootPulse: 0,
};

export type TouchKey = "left" | "right" | "jump" | "shoot";

export function resetTouchInput(): void {
  touchInput.left = false;
  touchInput.right = false;
  touchInput.jump = false;
  touchInput.shoot = false;
}

export function setTouchKey(key: TouchKey, value: boolean): void {
  if (key === "jump" && value && !touchInput.jump) {
    touchInput.jumpPulse += 1;
  }
  if (key === "shoot" && value && !touchInput.shoot) {
    touchInput.shootPulse += 1;
  }
  touchInput[key] = value;
}
